var _path, _path2, _g, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArtDeleteGeneral = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 191,
  height: 160,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FEEAE8",
  fillRule: "evenodd",
  d: "M75.645 32.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.622-58.698-60.688 1.531-27.357 38.565-27.82 64.193-37.513Z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "art_deleteGeneral_svg__a",
  width: 158,
  height: 127,
  x: 11,
  y: 8,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEEAE8",
  fillRule: "evenodd",
  d: "M75.645 32.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.622-58.698-60.688 1.531-27.357 38.565-27.82 64.193-37.513Z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#art_deleteGeneral_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F23015",
  d: "M95.974 65.797C75.001 65.797 58 61.85 58 56.98l4.343 74.122C62.343 136.15 75.17 144 95.974 144c20.805 0 33.635-7.85 33.635-12.899l4.34-74.122c0 4.871-17.001 8.819-37.975 8.819Zm-22.83 57.035-1.562-45.735a64.3 64.3 0 0 0 3.345.643l1.582 46.378a43.56 43.56 0 0 1-3.366-1.286Zm13.73 3.585-.845-47.409c1.087.075 2.189.148 3.31.184l.846 47.574a59.992 59.992 0 0 1-3.31-.349Zm18.2 0a60.867 60.867 0 0 1-3.328.349l.846-47.574a91.273 91.273 0 0 0 3.31-.183l-.828 47.408Zm13.731-3.585c-1.029.442-2.15.88-3.363 1.286l1.58-46.378a89.324 89.324 0 0 0 3.346-.643l-1.563 45.735Z"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F23015",
  d: "M115.539 28.595c2.248-6.333-1.016-13.299-7.346-15.607-6.33-2.3-13.311.937-15.66 7.233-14.793-3.09-26.852-1.462-28.177 2.177l-1.34 3.682c-1.666 4.577 12.96 14.101 32.668 21.275 19.709 7.173 37.034 9.278 38.7 4.7l1.34-3.681c1.325-3.639-6.867-12.637-20.185-19.78Zm-11.199-5.021a86.847 86.847 0 0 0-4.1-1.368 4.402 4.402 0 0 1 1.904-1.706 4.369 4.369 0 0 1 3.368-.148 4.38 4.38 0 0 1 2.489 2.28 4.38 4.38 0 0 1 .36 2.53 86.92 86.92 0 0 0-4.021-1.588Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3863F0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "m37.055 7.407 14.015 17.17M19.999 62.865l19.338-7.059M12.41 29.72l29.948 9.524"
})));
export default SvgArtDeleteGeneral;